
import EventTreeEdge from './EventTreeEdge';
import {mxConstants} from "mxgraph-js";

class EventTreeFailureEdge extends EventTreeEdge {
  constructor(value = 'no') {
    super(EventTreeFailureEdge.getMyStyle);
    this.setValue(value);
  }

  static get getMyStyle(): any {
    const styles = EventTreeEdge.getMyStyle();
    styles[mxConstants.STYLE_FILLCOLOR] = 'rgba(202,91,48,0.51)';
    styles[mxConstants.STYLE_STROKECOLOR] = 'rgba(202,67,65,0.71)';
    // the following enforces bottom to top connections
    styles[mxConstants.STYLE_EXIT_X] = 0.50;
    styles[mxConstants.STYLE_EXIT_Y] = 1;
    styles[mxConstants.STYLE_ENTRY_X] = 0;
    styles[mxConstants.STYLE_ENTRY_Y] = 0.5;
    return styles;
  }
}

export default EventTreeFailureEdge;
